import React from 'react';
import styled from 'styled-components';
import Loader from './loading';

interface LoadingOverlayProps {
  isLoading: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <OverlayContainer>
      <LoaderContainer>
        <Loader />
        <LoadingText>Cargando...</LoadingText>
      </LoaderContainer>
    </OverlayContainer>
  );
};

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const LoadingText = styled.div`
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`;

export default LoadingOverlay;
